var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0376 18.1113C3.60352 18.1113 3.91895 17.833 4.1416 17.1094L5.01367 14.4932H9.59668L10.4688 17.1094C10.6821 17.8237 11.0161 18.1113 11.582 18.1113C12.1851 18.1113 12.584 17.7588 12.584 17.2021C12.584 16.9702 12.5283 16.7197 12.4263 16.4136L8.94727 6.57031C8.63184 5.6333 8.17725 5.23438 7.33301 5.23438C6.48877 5.23438 6.03418 5.64258 5.70947 6.57031L2.23047 16.4136C2.10986 16.7661 2.0542 17.0073 2.0542 17.23C2.0542 17.7681 2.45312 18.1113 3.0376 18.1113ZM5.51465 12.8789L7.25879 7.52588H7.36084L9.0957 12.8789H5.51465Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7646 16.729H19.8667V17.165C19.9131 17.7495 20.2749 18.0928 20.8408 18.0928C21.481 18.0928 21.8428 17.6846 21.8428 16.9795V11.3667C21.8428 9.23291 20.4604 8.04541 17.9834 8.04541C16.9629 8.04541 16.1836 8.22168 15.5898 8.54639C14.7642 8.9917 14.3745 9.54834 14.3745 10.1143C14.3745 10.5596 14.6714 10.8657 15.126 10.8657C15.4785 10.8657 15.7197 10.7729 15.9702 10.5317C16.5361 9.95654 17.0742 9.67822 17.8535 9.67822C19.106 9.67822 19.7832 10.2534 19.7832 11.3574V12.2295H17.334C15.1445 12.2388 13.8271 13.3428 13.8271 15.1519C13.8271 16.9331 15.1167 18.1392 17.0278 18.1392C18.2432 18.1392 19.2266 17.6382 19.7646 16.729ZM15.896 15.0498C15.896 14.1499 16.5269 13.6396 17.6216 13.6396H19.7832V14.6973C19.7832 15.7549 18.8647 16.5713 17.668 16.5713C16.6104 16.5713 15.896 15.959 15.896 15.0498Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextOutline);
export default __webpack_public_path__ + "static/media/text_outline.9015af5830d3e445f3414aa8334f7eb6.svg";
export { ForwardRef as ReactComponent };